import { render, staticRenderFns } from "./ProductQuantity.vue?vue&type=template&id=71bcf5bf&scoped=true&"
import script from "./ProductQuantity.vue?vue&type=script&lang=js&"
export * from "./ProductQuantity.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuantity.vue?vue&type=style&index=0&id=71bcf5bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bcf5bf",
  null
  
)

export default component.exports